import React, { useState } from "react";
import { useParams } from "react-router";
import "../templates/jurisdiction.css";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import JurisdictionsDetail from "./JurisdictionDetail";
import CommonCertificateNotesForm from "../../../../components/common/CertificateNotesGrid/CertificateNotesGrid";
import {
    useDeleteCertificateNoteByIdMutation,
    useGetCertificateNotesByReferenceIdQuery
} from "../../../../components/common/CertificateNotesGrid/CertificateNotesApi";
import CertNoteAddOrUpdateModal from "../../../../components/common/CertificateNotesGrid/CertNoteAddOrUpdateModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import ModalButton from "../../../../components/common/form/ModalButton";
import IconButton from "../../../../components/common/form/IconButton";
import { FaTrash } from "react-icons/fa6";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import { Routes as AppRoutes } from "../../../../routes";
import { useNavigate } from "react-router-dom";
import { useDeleteJurisdictionMutation, useGetJurisdictionByIdQuery } from "../jurisdictionApi";

const JurisdictionDetailPage = () => {


    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Jurisdictions", url: "/jurisdictions" },
        { content: "Update Jurisdiction", url: "" }
    ]
    )
    let { jurisdictionId } = useParams();
    const navigate = useNavigate();
    const [noteObject, setNoteObject] = useState(null);
    const [showNoteUpdateModel, setShowNoteUpdateModel] = useState(false);
    const [certificateNoteId, setCertificateNoteId] = useState(null);
    const [showManagementCertificateModal, setShowManagementCertificateModal] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteNotesApi, { isLoading }] = useDeleteCertificateNoteByIdMutation();
    const jurisdictionDataById = useGetJurisdictionByIdQuery(jurisdictionId);
    const [deleteJurisdictionApi, deleteJurisdictionApiResponse] = useDeleteJurisdictionMutation();

    const {
        data: certificateNotes,
    } = useGetCertificateNotesByReferenceIdQuery(jurisdictionId || "");

    const handleDeleteCertificateNotes = async (e: any) => {
        e.preventDefault();
        if (certificateNoteId !== null && certificateNoteId !== '') {
            try {
                await deleteNotesApi(certificateNoteId);
                setShowDeleteConfirm(false);
            } catch (error) {
                console.error('Error deleting certificate note:', error);
            }
        }
    };

    const handleDeleteJurisdiction = async () => {
        if (jurisdictionId) {
            await deleteJurisdictionApi(jurisdictionId).unwrap();
        }
        navigate(AppRoutes.Jurisdiction.path)
    };

    return (
        <div className="user-container px-5 py-5">
            <div className={"justify-between sm:block md:flex lg:flex"}>
                <Breadcrumb crumbs={crumbs} />

                <div className={"justify-between sm:block md:flex lg:flex"}>
                    {hasPermission(["JURI-D"]) &&
                        <ModalButton
                            triggerButton={
                                <IconButton
                                    icon={<FaTrash />}
                                    title={"Delete Jurisdiction"}
                                    hasBackground={true}
                                    className="mr-2"
                                />
                            }
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title={"Delete Jurisdiction"}
                                    bodyMessage={"Are you sure you want to delete this Jurisdiction?"}
                                    onSubmit={() => handleDeleteJurisdiction()}
                                    isLoading={deleteJurisdictionApiResponse?.isLoading}
                                />
                            }
                        />}
                    {hasPermission(["AUDIT-V"]) && <AuditableInfoButton obj={jurisdictionDataById?.data} />}

                </div>

            </div>
            <div className="md:grid grid-cols-12 gap-4 mt-2">

                <div className="col-span-6  ">
                    <JurisdictionsDetail crumbs={crumbs} title={"Jurisdiction Detail"} btnText={"Update"}
                        isReadOnly={!hasPermission(["JURI-U"])} />
                </div>
                <div className="col-span-6 space-y-4">
                    {hasPermission(["CRTNOT-V"]) &&

                        <CommonCertificateNotesForm
                            title={"Jurisdiction Certificate Notes "}
                            data={certificateNotes}
                            relationalId={jurisdictionId}
                            count={certificateNotes?.length || 0}
                            setShowAddNoteModal={setShowManagementCertificateModal}
                            setNoteObject={setNoteObject}
                            setShowNoteUpdateModel={setShowNoteUpdateModel}
                            setNoteId={setCertificateNoteId}
                            setShowDeleteConfirm={setShowDeleteConfirm}
                        />
                    }
                    {showManagementCertificateModal &&
                        <CertNoteAddOrUpdateModal title={"Add Jurisdiction Certificate  Note"}
                            show={showManagementCertificateModal}
                            setShow={setShowManagementCertificateModal}
                            relationalId={jurisdictionId}
                            type={"Jurid"}
                            length={certificateNotes && certificateNotes.length + 1}
                            btnName="Add" />}


                    {showNoteUpdateModel &&
                        <CertNoteAddOrUpdateModal title={"Update Jurisdiction Certificate Notes "}
                            show={showNoteUpdateModel}
                            setShow={setShowNoteUpdateModel}
                            noteObj={noteObject}
                            relationalId={jurisdictionId}
                            btnName={"Update"} type={"Jurid"}
                        />
                    }

                    {showDeleteConfirm && <ConfirmationModal title={"Delete  Jurisdiction Certificate Notes"}
                        bodyMessage={"Are you sure you want to delete this certificate note?"}
                        onSubmit={handleDeleteCertificateNotes}
                        show={showDeleteConfirm}
                        setShow={setShowDeleteConfirm}
                        isLoading={isLoading}
                    />
                    }

                </div>
            </div>
        </div>
    );

};

export default JurisdictionDetailPage;